module.exports = __webpack_public_path__ + "static/media/marque-privilege.c4dcc82f.glb";